import { createRef, useState, useEffect, useRef } from "react";
import {
  Typography,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  Box,
  FormControl,
  InputLabel,
  Loading,
} from "../../components";
import {
  history,
  LoginService,
  notification,
  SessionService,
  ConfiguracoesService,
} from "../../services";
import { value, InputErros } from "../../helpers";
import { responseErros } from "../../utils";
import { loginValidator } from "./middlewares";
import ReCAPTCHA from "react-google-recaptcha";
import store from "../../config/store";
import {
  RecuperarSenhaDialogo,
  DialogoFiliais,
  ChatComponent,
} from "./components";
import "./login-style.scss";
import { float3D, sxInputLogin } from "./constantes.login";
const sessionService = new SessionService();
const loginService = new LoginService();
const configuracoesService = new ConfiguracoesService();
const versaoMobileAtiva = false;
const logoHorizontal =
  "https://public.siafevolution.com.br/logo-lite-horizontal.svg";
const floatingIcons = [
  {
    iconClass: "ph-bold ph-chart-line-up",
    top: "8%",
    right: "4%",
    size: "40px",
    delay: "0s",
    duration: "6s",
  },
  {
    iconClass: "ph-bold ph-users",
    top: "30%",
    right: "12%",
    size: "36px",
    delay: "0.3s",
    duration: "9s",
  },
  {
    iconClass: "ph-bold ph-file-text",
    bottom: "6%",
    right: "35%",
    size: "42px",
    delay: "0.8s",
    duration: "6.5s",
  },
];

const FloatingBackground = () => (
  <Box
    sx={{
      position: "fixed",
      inset: 0,
      overflow: "hidden",
      zIndex: 0,
      pointerEvents: "none",
    }}
  >
    {floatingIcons.map((item, index) => (
      <Box
        key={index}
        sx={{
          position: "absolute",
          top: item.top,
          left: item.left,
          right: item.right,
          bottom: item.bottom,
          opacity: 0.08,
          color: "white",
          transformStyle: "preserve-3d",
          animation: `${float3D} ${item.duration} ease-in-out infinite`,
          animationDelay: item.delay,
          fontSize: item.size,
        }}
      >
        <i className={item.iconClass}></i>
      </Box>
    ))}
  </Box>
);

const LoginView = () => {
  const [login, setLogin] = useState({});
  const [loading, setLoading] = useState(false);
  const [inputErro, setInputErro] = useState([]);
  const [tempoBloqueio, setTempoBloqueio] = useState("5:00");
  const [usuarioBloqueado, setUsuarioBloqueado] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [tokenRecaptcha, setTokenRecaptcha] = useState(null);
  const [erro, setErro] = useState(false);
  const [abrirDialogoRecuperarSenha, setAbrirDialogoRecuperarSenha] =
    useState(false);
  const [dados, setDados] = useState(false);
  const [abrirDialogoFiliais, setAbrirDialogoFiliais] = useState(false);
  const loginViaMensagemProcessadoRef = useRef(null);
  const recaptchaRef = createRef();
  const inputErros = new InputErros(inputErro, setInputErro);

  useEffect(() => {
    if (versaoMobileAtiva) {
      verificarVersaoMobile();
    }
  }, []);

  useEffect(() => {
    const onMessageReceberLoginEmpresa = (event) => {
      if (event.source !== window.opener) return;
      const payload = event.data;
      if (!payload || payload.type !== "SIAF_EVOLUTION_EMPRESA_LOGIN") return;
      const requestId = payload.requestId || "default";
      if (loginViaMensagemProcessadoRef.current === requestId) {
        event.source?.postMessage(
          {
            type: "SIAF_EVOLUTION_EMPRESA_LOGIN_ACK",
            requestId,
          },
          event.origin,
        );
        return;
      }
      if (!payload.token || !payload.dados) {
        return notification.alertaGenericos(
          "Dados inválidos recebidos para autenticação",
        );
      }
      if (document.referrer) {
        try {
          const origemReferrer = new URL(document.referrer).origin;
          if (origemReferrer !== event.origin) return;
        } catch {
          return;
        }
      }
      loginViaMensagemProcessadoRef.current = requestId;
      cadastrarSesson({
        token: payload.token,
        dados: payload.dados,
      });
      event.source?.postMessage(
        {
          type: "SIAF_EVOLUTION_EMPRESA_LOGIN_ACK",
          requestId,
        },
        event.origin,
      );
    };
    window.addEventListener("message", onMessageReceberLoginEmpresa);
    return () => {
      window.removeEventListener("message", onMessageReceberLoginEmpresa);
    };
  }, []);

  const verificarVersaoMobile = () => {
    if (navigator.userAgentData) {
      if (navigator.userAgentData.mobile) {
        return window.location.replace(store.urlMobile);
      }
      return;
    }
    if (navigator.userAgent) {
      if (/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        return window.location.replace(store.urlMobile);
      }
      return;
    }
    if (window.matchMedia("(max-width: 768px)").matches) {
      return window.location.replace(store.urlMobile);
    }
  };

  const onSubmitLogar = (event) => {
    event.preventDefault();
    setErro(false);
    if (!tokenRecaptcha && store.enviroment == "production") {
      return notification.alertaGenericos("Resolva o reCAPTCHA");
    }
    loginValidator
      .validate(login, { abortEarly: false })
      .then(logar())
      .catch((err) => inputErros.set(err));
  };

  function cadastrarSesson(data) {
    sessionService.setSession(data);
    if (
      data.diasVencimento &&
      data.diasVencimento > 0 &&
      data.diasVencimento <= 10
    ) {
      notification.confirmacaoGenericos({
        icon: "warning",
        title: "Atenção",
        text: `Sua licença irá expirar em ${data.diasVencimento} dia${
          data.diasVencimento > 1 ? "s" : ""
        }. Consulte o suporte para a regularização.`,
        confirmButtonText: "OK",
      });
    }
    if (data.dados.usuario?.acessosEmpresas?.length > 1) {
      setDados(data.dados);
      setAbrirDialogoFiliais(true);
    } else {
      buscarConfiguracoesEmpresa();
      history.push("/dashboard");
    }
  }

  const logar = async () => {
    setLoading(true);
    const res = await loginService.logar(
      login,
      store.enviroment == "production" ? tokenRecaptcha : "teste",
    );
    setLoading(false);
    if (!res.isAxiosError) {
      cadastrarSesson(res.data);
    } else {
      if (res.response && res.response.status == 400) {
        setErro(true);
        notification.alertaGenericos(
          res.response.data.message || res.response.data,
        );
        if (
          res.response.data.message ==
          "Este usuário está bloqueado temporariamente"
        ) {
          bloquearUsuario();
        }
      } else {
        responseErros(res);
      }
      window.grecaptcha.reset();
      setTokenRecaptcha(null);
    }
  };

  const onChangeInput = (event) => {
    setLogin((prevState) => ({
      ...prevState,
      [event.target.name]: String(event.target.value).trim(),
    }));
  };

  function buscarConfiguracoesEmpresa() {
    configuracoesService.get().then((res) => {
      if (!res.isAxiosError) {
        sessionService.setConfiguracoesEmpresa(res.data.rows[0]);
      }
    });
  }

  function bloquearUsuario() {
    setUsuarioBloqueado(true);
    let minutos = 4;
    let segundos = 60;
    const interval = setInterval(() => {
      segundos--;
      if (segundos == 0) {
        if (minutos == 0) {
          setTempoBloqueio("5:00");
          setUsuarioBloqueado(false);
          clearInterval(interval);
          return;
        }
        segundos = 60;
        minutos--;
      }
      const segundosFormatado = segundos < 10 ? `0${segundos}` : segundos;
      setTempoBloqueio(`${minutos}:${segundosFormatado}`);
    }, 1000);
  }

  function onChangeRecaptcha(value) {
    setTokenRecaptcha(value);
  }

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const onClickAbrirDialogoRecuperarSenha = (e) => {
    e.preventDefault();
    setAbrirDialogoRecuperarSenha(true);
  };

  return (
    <>
      <FloatingBackground />
      <main
        className="w-100 d-flex p-5 bg-white"
        style={{
          height: "100vh",
        }}
      >
        <ChatComponent />
        <Box
          className="login d-flex flex-column justify-content-center fw-bold h-100 px-5"
          sx={{
            width: "40%",
          }}
        >
          <Box>
            <Box className="d-flex">
              <img
                src={logoHorizontal}
                width={"200rem"}
                style={{ marginBottom: "3rem" }}
              />
            </Box>
            {usuarioBloqueado && (
              <span className="text-danger">
                Usuário bloqueado por {tempoBloqueio}
              </span>
            )}
            <form onSubmit={onSubmitLogar} className="mt-2">
              <FormControl variant="standard" fullWidth>
                <InputLabel shrink htmlFor="email">
                  Email
                </InputLabel>
                <TextField
                  variant="standard"
                  id="email"
                  name="email"
                  type="text"
                  margin="normal"
                  fullWidth
                  InputProps={{
                    disableUnderline: true,
                  }}
                  sx={sxInputLogin}
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(event) => onChangeInput(event)}
                  value={value.text(login.email)}
                  error={inputErros.get("email") || erro ? true : false}
                />
              </FormControl>
              <FormControl variant="standard" fullWidth className="mt-3">
                <InputLabel shrink htmlFor="senha">
                  Senha
                </InputLabel>
                <TextField
                  variant="standard"
                  name="senha"
                  id="senha"
                  margin="normal"
                  fullWidth
                  required
                  sx={sxInputLogin}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  type={showPassword ? "text" : "password"}
                  onChange={(event) => onChangeInput(event)}
                  value={value.text(login.senha)}
                  error={inputErros.get("senha") || erro ? true : false}
                  InputProps={{
                    disableUnderline: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={handleClickShowPassword}>
                          {showPassword ? (
                            <i
                              className="ph-fill ph-eye"
                              style={{ color: "#494C62", fontSize: 18 }}
                            ></i>
                          ) : (
                            <i
                              className="ph-fill ph-eye-slash"
                              style={{ color: "#494C62", fontSize: 18 }}
                            ></i>
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>
              <Typography variant="body2" gutterBottom sx={{ mb: 2 }}>
                <a
                  style={{ textDecoration: "none" }}
                  href="#"
                  onClick={(e) => onClickAbrirDialogoRecuperarSenha(e)}
                >
                  Esqueci minha senha
                </a>
              </Typography>
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={store.keyRecaptcha}
                onChange={onChangeRecaptcha}
                size="normal"
              />
              <Button
                fullWidth
                variant="contained"
                disabled={usuarioBloqueado}
                size="large"
                type="submit"
                className="mt-3 fw-bold rounded-3"
                sx={{ textTransform: "capitalize" }}
                color={usuarioBloqueado ? "padrao" : "primary"}
                disableElevation
              >
                Entrar
              </Button>
            </form>
          </Box>
        </Box>
        <RecuperarSenhaDialogo
          abrirDialogoRecuperarSenha={abrirDialogoRecuperarSenha}
          setAbrirDialogoRecuperarSenha={setAbrirDialogoRecuperarSenha}
          setLoading={setLoading}
        />
        <DialogoFiliais
          abrirDialogoFiliais={abrirDialogoFiliais}
          setAbrirDialogoFiliais={setAbrirDialogoFiliais}
          dados={dados}
          setLoading={setLoading}
          buscarConfiguracoesEmpresa={buscarConfiguracoesEmpresa}
        />
        <Loading loading={loading} />
      </main>
    </>
  );
};

export default LoginView;
